import React, { useEffect, useState } from "react";
import DataTable from "../../../../Components/Others/DataTable";
import ViewToggle from "../../../../Components/Utils/ViewToggle";
import {
  CancelButton,
  CreateButton,
  FilterButton,
  ImportButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import { Link, useLocation } from "react-router-dom";
import SearchBar from "../../../../Components/Utils/SearchBar";
import UseGetData from "../../../../Components/Hooks/useFetchData";
import MoreOptions from "../../../../Components/Utils/MoreOptions";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import CustomDataTable from "../../../../Components/Others/CustomDataTable";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import { useFormik } from "formik";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { NuDate } from "../../../../Components/Utils/Input";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import * as yup from "yup";
import Importdoc from "./Importdoc";
import MultiEditPr from "./MultiEditPr";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import {
  GetAccess,
  GetMultipleAccess,
  GetMultiRole,
  GetRole,
  CheckEditAction,
  CheckDeleteAction,
} from "../../../../Components/Utils/roles";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import PremiumTable, { CopyButton } from "../../../../Components/Others/PremiumTable";
import { useDeleteData } from "../../../../Components/Hooks/useDeleteData";
import dayjs from "dayjs";
import ActionButtons, { DeleteButton, EditButton, ViewButton, ToggleReadButton } from "../../../../Components/Utils/ActionButtons ";
import axiosInstance from "../../../../Services/axiosCommon";
import { useToast } from "../../../../Components/Others/ToastServices";

// Icons for Approval Status
const HourglassIcon = () => (
  <svg className="w-4 h-4 text-amber-500 animate-pulse shrink-0" viewBox="0 0 384 512" fill="currentColor" title="Pending">
    <path d="M360 0H24C10.7 0 0 10.7 0 24v16c0 13.3 10.7 24 24 24h16v96c0 56.6 32.7 105.6 80 128-47.3 22.4-80 71.4-80 128v96H24c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24h-16v-96c0-56.6-32.7-105.6-80-128 47.3-22.4 80-71.4 80-128V64h16c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24zm-80 448H104v-48c0-44.1 35.9-80 80-80s80 35.9 80 80v48zm0-240v16H104v-16c0-44.1 35.9-80 80-80s80 35.9 80 80z" />
  </svg>
);

const ApprovedIcon = () => (
  <svg className="w-4 h-4 text-emerald-500 shrink-0" viewBox="0 0 512 512" fill="currentColor" title="Approved">
    <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm108.384 186.758l-140.2 140.2c-4.7 4.7-12.3 4.7-17 0l-71.8-71.8c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l46.3 46.3 114.7-114.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17z" />
  </svg>
);

const RejectedIcon = () => (
  <svg className="w-4 h-4 text-red-500 shrink-0" viewBox="0 0 512 512" fill="currentColor" title="Rejected">
    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm88.3 325.3c4.7 4.7 4.7 12.3 0 17l-19.8 19.8c-4.7 4.7-12.3 4.7-17 0L256 312.8 204.5 364c-4.7 4.7-12.3 4.7-17 0l-19.8-19.8c-4.7-4.7-4.7-12.3 0-17l51.5-51.5-51.5-51.5c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0l51.5 51.5 51.5-51.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17L297.2 256l57.1 57.3z" />
  </svg>
);

const VerifiedIcon = () => (
  <svg className="w-4 h-4 text-purple-500 shrink-0" viewBox="0 0 384 512" fill="currentColor" title="Verified">
    <path d="M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm108.3 186.7l-114.7 114.7c-4.7 4.7-12.3 4.7-17 0l-46.3-46.3c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l46.3 46.3 114.7-114.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17z" />
  </svg>
);

const ReviewedIcon = () => (
  <svg className="w-4 h-4 text-indigo-500 shrink-0" viewBox="0 0 384 512" fill="currentColor" title="Reviewed">
    <path d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm96-136.5V128H256V0h9.5c6.4 0 12.5 2.5 17 7l98.5 98.5c4.5 4.5 7 10.6 7 17z" />
  </svg>
);

const renderApprovalStatusIcon = (status) => {
  const s = String(status || "").toLowerCase().trim();
  if (s === "approved") return <ApprovedIcon />;
  if (s === "pending") return <HourglassIcon />;
  if (s === "rejected" || s === "declined") return <RejectedIcon />;
  if (s === "verified") return <VerifiedIcon />;
  if (s === "reviewed") return <ReviewedIcon />;
  return null;
};

const getPRStatusBadgeClass = (status) => {
  const s = String(status || "").toLowerCase().trim();
  switch (s) {
    case "completed":
    case "approved":
    case "customer quote approved":
      return "bg-emerald-50 text-emerald-700 border-emerald-100";
    case "pending":
      return "bg-amber-50 text-amber-700 border-amber-100";
    case "pr created":
      return "bg-slate-50 text-slate-700 border-slate-200";
    case "rfq floated":
      return "bg-blue-50 text-blue-700 border-blue-100";
    case "supplier price received":
      return "bg-cyan-50 text-cyan-700 border-cyan-100";
    case "quote submitted to customer":
      return "bg-indigo-50 text-indigo-700 border-indigo-100";
    case "po received from customer":
      return "bg-violet-50 text-violet-700 border-violet-100";
    case "lost the order":
      return "bg-rose-50 text-rose-700 border-rose-100";
    case "sales order released":
      return "bg-teal-50 text-teal-700 border-teal-100";
    case "verified":
      return "bg-purple-50 text-purple-700 border-purple-100";
    case "reviewed":
      return "bg-sky-50 text-sky-700 border-sky-100";
    default:
      return "bg-gray-50 text-gray-600 border-gray-100";
  }
};

// PR Progress Timeline Component
const PRProgressTimeline = ({ tracker }) => {
  const stepsByOrder = Object.fromEntries(
    tracker?.map((step) => [step.order, step]) || []
  );

  const isStepActiveFast = (order, statuses = []) =>
    statuses.includes(stepsByOrder?.[order]?.status);

  const rawActive1 = isStepActiveFast(1, ["PR Created"]);
  const rawActive2 = isStepActiveFast(2, ["RFQ Floated"]);
  const rawActive3 = isStepActiveFast(3, ["Supplier Price Received"]);
  const rawActive4 = isStepActiveFast(4, ["Customer Quote Approved"]);
  const rawActive5 = isStepActiveFast(5, ["Quote Submitted to Customer"]);
  const rawActive6 = isStepActiveFast(6, [
    "PO Received from customer",
    "Lost the Order",
  ]);
  const rawActive7 = isStepActiveFast(7, ["Sales Order Released"]);

  const isActive7 = rawActive7 || stepsByOrder?.[7]?.date;
  const isActive6 = rawActive6 || stepsByOrder?.[6]?.date || isActive7;
  const isActive5 = rawActive5 || stepsByOrder?.[5]?.date || isActive6;
  const isActive4 = rawActive4 || stepsByOrder?.[4]?.date || isActive5;
  const isActive3 = rawActive3 || stepsByOrder?.[3]?.date || isActive4;
  const isActive2 = rawActive2 || stepsByOrder?.[2]?.date || isActive3;
  const isActive1 = rawActive1 || stepsByOrder?.[1]?.date || isActive2;

  // Icons
  const prIcon = (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  );
  const rfqIcon = (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
    </svg>
  );
  const supplierIcon = (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
    </svg>
  );
  const customerIcon = (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );
  const quoteIcon = (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
  );
  const poIcon = (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
    </svg>
  );
  const salesIcon = (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
    </svg>
  );

  const steps = [
    { title: "YPR Created", active: isActive1, date: stepsByOrder?.[1]?.date, icon: prIcon },
    { title: "RFQ Floated", active: isActive2, date: stepsByOrder?.[2]?.date, icon: rfqIcon },
    { title: "Supplier Price Received", active: isActive3, date: stepsByOrder?.[3]?.date, icon: supplierIcon },
    { title: "Customer Quote Approved", active: isActive4, date: stepsByOrder?.[4]?.date, icon: customerIcon },
    { title: "Quote Submitted to Customer", active: isActive5, date: stepsByOrder?.[5]?.date, icon: quoteIcon },
    {
      title: stepsByOrder?.[6]?.status === "PO Received from customer"
        ? "PO Received from customer"
        : stepsByOrder?.[6]?.status === "Lost the Order"
          ? "Lost the Order"
          : "PO Received / Lost Order",
      active: isActive6,
      date: stepsByOrder?.[6]?.date,
      icon: poIcon
    },
    { title: "Sales Order Released", active: isActive7, date: stepsByOrder?.[7]?.date, icon: salesIcon },
  ];

  let activeCount = 0;
  if (isActive1) activeCount = 1;
  if (isActive2) activeCount = 2;
  if (isActive3) activeCount = 3;
  if (isActive4) activeCount = 4;
  if (isActive5) activeCount = 5;
  if (isActive6) activeCount = 6;
  if (isActive7) activeCount = 7;

  const activePercent = activeCount > 1 ? ((activeCount - 1) / 6) * 100 : 0;
  const lastActiveIdx = activeCount - 1;

  return (
    <div className="w-full overflow-x-auto">
      <div className="relative py-4 pl-4 pr-4 w-max min-w-full">
        {/* Connecting Line Track Container */}
        <div className="absolute top-[38px] left-[48px] right-[55px] z-0 pointer-events-none">
          <div className="relative w-full h-[2px]">
            <div className="absolute left-0 right-0 top-0 bottom-0 bg-gray-200" />
            <div
              className="absolute left-0 top-0 bottom-0 bg-green-500 transition-all duration-500"
              style={{ width: `${activePercent}%` }}
            />
          </div>
        </div>

        {/* Row of Step Columns */}
        <div className="relative flex justify-between items-start w-full min-w-max z-10">
          {steps.map((step, idx) => {
            const formattedDate = step.active && step.date ? dayjs(step.date).format("DD-MMM-YYYY") : "--";
            const formattedTime = step.active && step.date ? dayjs(step.date).format("hh:mm A") : "--";

            let alignClass = "items-center text-center";
            if (idx === 0) {
              alignClass = "items-start text-left";
            } else if (idx === 6) {
              alignClass = "items-end text-right";
            }

            return (
              <div key={idx} className={`flex flex-col w-[120px] shrink-0 ${alignClass}`}>
                <div className="h-11 w-11 flex items-center justify-center mb-2 relative">
                  {idx === lastActiveIdx && (
                    <div
                      className="absolute w-9 h-9 rounded-full bg-green-900 animate-ping z-0 pointer-events-none"
                    />
                  )}
                  <div
                    className={`w-10 h-10 rounded-full flex items-center justify-center border-2 z-10 transition-all duration-300 ${step.active
                      ? "border-baseColor-primary bg-baseColor-primary text-white shadow-[0_0_10px_rgba(4,129,120,0.25)]"
                      : "bg-white border-gray-200 text-gray-400"
                      }`}
                  >
                    {step.icon}
                  </div>
                </div>

                {/* Label and Date */}
                <p className={`text-xs font-semibold leading-snug ${step.active ? "text-gray-800" : "text-gray-400"}`}>
                  {step.title}
                </p>
                <p className="text-xs text-gray-600 font-semibold mt-1 leading-tight">
                  {formattedDate}
                </p>
                <p className="text-xs text-gray-600 font-semibold leading-tight">
                  {formattedTime}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

// PR Table Row Component
const PRTableRow = ({
  row,
  isSelected,
  onSelect,
  pageIndex,
  searchQuery,
  canEdit,
  canDelete,
  handleDelete,
  onToggleRead,
  loadingPrId,
}) => {
  const formattedDate = row.formattedDate || "--";
  const formattedDeadline = row.formattedDeadline || "--";

  const showCustomer = GetMultiRole(["admin", "super admin", "sales", "sales co-ordinator"]);
  const showAssignee = GetMultiRole(["admin", "super admin", "management", "manager", "coordinator", "sales co-ordinator", "proc co-ordinator"]);
  const showSalesman = GetMultiRole(["admin", "super admin", "management", "manager", "coordinator"]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const isUnread = !row.isRead;

  const topBorderClass = isUnread ? "border-t-2 border-orange-500" : "border-t border-gray-200/60";
  const leftBorderClass = isUnread ? "border-l-2 border-orange-500" : "border-l border-gray-200/60";
  const rightBorderClass = isUnread ? "border-r-2 border-orange-500" : "border-r border-gray-200/60";
  const bottomTimelineClass = isUnread
    ? "border-l-2 border-r-2 border-b-2 border-orange-500 border-t border-t-gray-100"
    : "border-l border-r border-b border-gray-200/40 border-t border-gray-100";

  const handle = async () => handleDelete("/PR/" + `${row.prId}`, setIsModalOpen);
  return (
    <>
      <tr className="bg-white h-[40px] hover:bg-white/80 transition-colors align-middle border-b border-gray-100">
        {/* Checkbox */}
        <td className={`px-4 text-center align-middle rounded-tl-xl ${topBorderClass} ${leftBorderClass}`}>
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onSelect}
            className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 h-4 w-4 cursor-pointer"
          />
        </td>

        {/* YPR */}
        <td className={`px-4 align-middle font-semibold text-sm text-gray-800 whitespace-nowrap ${topBorderClass}`}>
          <div className="flex items-center gap-1.5">
            {/* {isUnread && (
              <span
                className="w-2 h-2 rounded-full bg-orange-500 shrink-0"
                title="Unread"
              />
            )} */}
            <Link
              to={`/procurement/purchase-requests/view/${row.prId}`}
              state={{
                data: row,
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="hover:underline text-sm font-bold text-gray-800"
            >
              {row.ref || "N/A"}
            </Link>
            <CopyButton text={row.ref} />
          </div>
        </td>

        {/* Customer */}
        {showCustomer && (
          <td className={`px-4 align-middle text-xs font-semibold text-gray-600 ${topBorderClass}`}>
            {row.customerName || "N/A"}
          </td>
        )}

        {/* RFQ Assignee */}
        {showAssignee && (
          <td className={`px-4 align-middle text-xs font-semibold text-gray-600 ${topBorderClass}`}>
            {row.rfqAssigneeNames?.join(", ") || "N/A"}
          </td>
        )}

        {/* Assign Date */}
        <td className={`px-4 align-middle text-xs font-semibold text-gray-600 whitespace-nowrap ${topBorderClass}`}>
          {formattedDate}
        </td>

        {/* Deadline */}
        <td className={`px-4 align-middle text-xs font-semibold text-gray-600 whitespace-nowrap ${topBorderClass}`}>
          {formattedDeadline}
        </td>

        {/* Days Elapsed */}
        <td className={`px-4 align-middle text-xs font-semibold text-gray-600 whitespace-nowrap ${topBorderClass}`}>
          {row.daysElapsed || "0"}
        </td>

        {/* Salesman */}
        {showSalesman && (
          <td className={`px-4 align-middle text-xs font-semibold text-gray-600 ${topBorderClass}`}>
            {row.salesPersonName || "N/A"}
          </td>
        )}

        {/* Status */}
        <td className={`px-4 align-middle whitespace-nowrap ${topBorderClass}`}>
          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${getPRStatusBadgeClass(row.status)}`}>
            {row.status || "N/A"}
          </span>
        </td>

        {/* Action Buttons */}
        <td className={`px-4 text-center align-middle rounded-tr-xl ${topBorderClass} ${rightBorderClass}`}>
          <div className="flex items-center justify-center gap-1.5">
            <ActionButtons
              row={row}
              canEdit={canEdit}
              canDelete={canDelete}
              onToggleRead={onToggleRead}
              isTogglingRead={loadingPrId === row.prId}
              viewUrl={`/procurement/purchase-requests/view/${row.prId}`}
              editUrl={`/procurement/purchase-requests/edit/${row.prId}`}
              viewState={{
                data: row,
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              editState={{
                data: row,
                from: "/procurement/purchase-requests",
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              onDelete={(row) => {
                setIsModalOpen(true);
              }}
              moduleName="YPR"
            />
          </div>
        </td>
      </tr>
      <tr className="bg-white">
        <td colSpan={12} className={`px-4 bg-[#FAFAFC]/40 rounded-bl-xl rounded-br-xl ${bottomTimelineClass}`}>
          <PRProgressTimeline tracker={row.tracker} />
        </td>
      </tr>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.ref} will removed from PR!`}
        handleClick={() => handle()}
        closeModal={() => setIsModalOpen(false)}
      />
    </>
  );
};

// PR Card Component
const PRCard = ({
  row,
  isSelected,
  onSelect,
  pageIndex,
  searchQuery,
  canEdit,
  canDelete,
  handleDelete,
  onToggleRead,
  loadingPrId,
}) => {
  const formattedDate = row.formattedDate || "--";
  const formattedDeadline = row.formattedDeadline || "--";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isUnread = !row.isRead;

  const handle = async () => handleDelete("/PR/" + `${row.prId}`, setIsModalOpen);
  return (
    <div
      className={`relative border shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)] transition-all duration-300 rounded-2xl bg-white p-2 sm:p-4 flex flex-col gap-3.5 overflow-hidden ${isUnread
        ? "border-2 border-orange-500 border-l-4 border-l-orange-500"
        : "border-y-gray-200/50 border-r-gray-200/50 border-l-4 border-l-sky-500"
        }`}
    >
      {/* Card Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start gap-3">
        <div className="flex items-center gap-2.5 min-w-0 flex-1">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onSelect}
            className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 h-4 w-4 cursor-pointer shrink-0"
          />
          <div className="flex flex-col min-w-0 flex-1">
            <div className="flex items-center gap-1.5">
              {/* {isUnread && (
                <span
                  className="w-2 h-2 rounded-full bg-orange-500 shrink-0"
                  title="Unread"
                />
              )} */}
              <Link
                to={`/procurement/purchase-requests/view/${row.prId}`}
                state={{
                  data: row,
                  pageIndex: pageIndex,
                  searchQuery: searchQuery,
                }}
                className="text-gray-800 font-bold hover:underline text-sm truncate"
              >
                {row.ref || "N/A"}
              </Link>
            </div>
            <span className="text-[10px] text-gray-400 font-bold mt-0.5 truncate">Salesman: {row.salesPersonName || "N/A"}</span>
          </div>
        </div>

        {/* Status & Approval Icon */}
        <div className="flex items-center gap-2 shrink-0">
          {renderApprovalStatusIcon(row.approvalStatus)}
          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${getPRStatusBadgeClass(row.status)}`}>
            {row.status || "N/A"}
          </span>
        </div>
      </div>

      {/* Middle Grid */}
      <div className="bg-[#FAFAFC]/80 rounded-xl p-3 border border-gray-100 flex flex-col gap-2 text-xs">
        <div className="flex justify-between items-center gap-2">
          <span className="text-xs font-semibold text-gray-600 tracking-wider shrink-0">Customer</span>
          <span className="font-bold text-gray-700 truncate max-w-[200px] sm:max-w-[300px]">{row.customerName || "--"}</span>
        </div>
        <div className="flex justify-between items-center gap-2">
          <span className="text-xs font-semibold text-gray-600 tracking-wider shrink-0">Assignee</span>
          <span className="font-bold text-gray-700 truncate max-w-[150px]">{row.rfqAssigneeNames || "--"}</span>
        </div>
      </div>

      {/* Date details */}
      <div className="flex flex-col gap-1 px-1 text-xs text-gray-600 font-medium">
        <div className="flex justify-between items-center">
          <span>Assign Date:</span>
          <span className="font-semibold text-gray-800">{formattedDate}</span>
        </div>
        <div className="flex justify-between items-center">
          <span>Deadline:</span>
          <span className="font-semibold text-gray-800">{formattedDeadline}</span>
        </div>
        <div className="flex justify-between items-center">
          <span>Days Elapsed:</span>
          <span className="font-semibold text-red-500">{row.daysElapsed || "0"} days</span>
        </div>
      </div>

      {/* Progress Timeline */}
      <div className="border-t border-gray-100 pt-2 overflow-x-auto">
        <PRProgressTimeline tracker={row.tracker} />
      </div>

      {/* Action Buttons Row */}
      <div className="flex flex-wrap sm:flex-nowrap items-center justify-between gap-2 border-t border-gray-100 pt-3 mt-1">
        <div className="flex items-center gap-2">
          {onToggleRead && (
            <ToggleReadButton
              isRead={row?.isRead}
              onToggle={() => onToggleRead(row?.prId, row?.isRead)}
              isLoading={loadingPrId === row?.prId}
            />
          )}
          <ViewButton viewLink={`/procurement/purchase-requests/view/${row.prId}`} viewState={{
            data: row,
            pageIndex: pageIndex,
            searchQuery: searchQuery,
          }} />
        </div>

        <div className="flex gap-2 flex-1 sm:flex-none justify-end">
          {CheckEditAction(row, "YPR", canEdit) && (
            <EditButton editLink={`/procurement/purchase-requests/edit/${row.prId}`} editState={{
              data: row,
              from: "/procurement/purchase-requests",
              pageIndex: pageIndex,
              searchQuery: searchQuery,
            }} />
          )}
          {CheckDeleteAction(row, canDelete) && (
            <DeleteButton onDelete={() => { setIsModalOpen(true); }} />
          )}
        </div>
      </div>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.ref} will removed from PR!`}
        handleClick={() => handle()}
        closeModal={() => setIsModalOpen(false)}
      />
    </div>
  );
};

function PRIndex() {
  const location = useLocation();
  const currentPage = location.state?.currentPage;
  const searchQuery = location.state?.searchQuery;
  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20,
  );

  const state = location.state;

  const [filter, setFilter] = useState(
    state?.approvalStatus || state?.category ? true : false,
  );
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [viewMode, setViewMode] = useState(localStorage.getItem("prViewMode") || "table");
  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileScreen(window.innerWidth < 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const effectiveViewMode = isMobileScreen ? "card" : viewMode;

  const { value: status } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "rfqStatus_pr",
    showFilterDialog,
  );
  const { value: Category } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "category_Customer",
    showFilterDialog,
  );

  const { data: RFQAssignee } = UseDropDown("/user/procurement/drop-down");
  const { data: Salesman } = UseDropDown("/user/salesman/drop-down");

  const [filterProps, setFilterProps] = useState({
    status: "",
    rfqAssignee: "",
    salesPerson: "",
    approvalStatus: "",
    deadLineFrom: "",
    deadLineTo: "",
    category: "",
    isRead: "",
  });

  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",
    status: "",
    rfqAssignee: "",
    salesPerson: "",
    deadLineFrom: "",
    deadLineTo: "",
    approvalStatus: state?.approvalStatus ? state.approvalStatus : "",
    category: state?.category ? state.category : "",
    isRead: "",
  });

  useEffect(() => {
    if (searchQuery) {
      setParams({ ...params, search: searchQuery });
    }
  }, [searchQuery]);

  const clearFilter = () => {
    setParams({
      ...params,
      category: "",
      status: "",
      approvalStatus: "",
      salesPerson: "",
      rfqAssignee: "",
      deadLineFrom: "",
      deadLineTo: "",
      isRead: "",
    });
    formik.values.category = "";
    formik.values.status = "";
    formik.values.approvalStatus = "";
    formik.values.salesPerson = "";
    formik.values.rfqAssignee = "";
    formik.values.deadLineFrom = "";
    formik.values.deadLineTo = "";
    formik.values.isRead = "";

    setFilter(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({}),
    onSubmit: async (value, { resetForm }) => {
      setParams({
        ...params,
        status: value.status,
        approvalStatus: value.approvalStatus,
        category: value.category,
        salesPerson: value.salesPerson,
        rfqAssignee: value.rfqAssignee,
        deadLineFrom: value.deadLineFrom,
        deadLineTo: value.deadLineTo,
        isRead: value.isRead !== "" ? value.isRead : "",
        page: 1,
      });
      setPage(1);
      closeFilterDialog();
      const isAnyFilterActive = Boolean(
        value.status ||
        value.approvalStatus ||
        value.category ||
        value.salesPerson ||
        value.rfqAssignee ||
        value.deadLineFrom ||
        value.deadLineTo ||
        (value.isRead !== "" && value.isRead !== undefined)
      );
      setFilter(isAnyFilterActive);
    },
  });

  const { data, totalCount, getData, dataLoading } = UseGetDataSearch(
    "/PR/",
    params,
  );

  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount });
  }, [page, pageCount]);

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };

  const [showImportModal, setShowImportModal] = useState(false);
  const handleImportClick = () => {
    setShowImportModal(true);
  };
  const closeModal = () => {
    setShowImportModal(false);
  };

  const canEdit = GetAccess("purchase_request_edit") || GetRole();
  const canDelete = GetAccess("purchase_request_delete") || GetRole();
  const { handle: handleDelete } = useDeleteData(getData);
  const toast = useToast();
  const [loadingPrId, setLoadingPrId] = useState(null);

  const handleToggleReadStatus = async (prId, currentIsRead) => {
    const newIsRead = !currentIsRead;
    setLoadingPrId(prId);
    try {
      const response = await axiosInstance.post(`/PR/toggle-read-status/${prId}`, {
        isRead: newIsRead,
      });
      if (response?.data?.status !== false) {
        toast.open({
          type: "success",
          message: "Success",
          description:
            response?.data?.msg ||
            response?.data?.message ||
            `Marked as ${newIsRead ? "read" : "unread"} successfully`,
        });
        getData();
      } else {
        toast.open({
          type: "error",
          message: "Error",
          description:
            response?.data?.error ||
            response?.data?.msg ||
            response?.data?.message ||
            "Failed to update read status",
        });
      }
    } catch (error) {
      toast.open({
        type: "error",
        message: "Error",
        description:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          "Failed to update read status",
      });
    } finally {
      setLoadingPrId(null);
    }
  };

  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [listofNumbers, setListofNumbers] = useState([]);
  const [fullList, setFullList] = useState([]);

  const selectOneFunction = (value) => {
    let NewId;
    if (listofNumbers && listofNumbers.some((Item) => Item === value)) {
      NewId = listofNumbers.filter((Temp) => Temp !== value);
      setListofNumbers(NewId);
    } else {
      setListofNumbers([...listofNumbers, value]);
    }
  };

  const selectMultipleFunction = (e) => {
    if (e.target.checked) {
      setListofNumbers(fullList);
    } else {
      setListofNumbers([]);
    }
  };

  useEffect(() => {
    let tempArr = [];
    data &&
      data.forEach((i) => {
        tempArr.push(i?.prId);
      });
    setFullList(tempArr);
  }, [data]);

  const processedData = React.useMemo(() => {
    if (!data || !Array.isArray(data)) return [];
    return data.map((item) => {
      const formattedDate = item.date
        ? dayjs(item.date).format("DD-MMM-YYYY")
        : "--";
      const formattedDeadline = item.deadLine
        ? dayjs(item.deadLine).format("DD-MMM-YYYY")
        : "--";
      return {
        ...item,
        formattedDate,
        formattedDeadline,
      };
    });
  }, [data]);

  const showCustomer = GetMultiRole(["admin", "super admin", "sales", "sales co-ordinator"]);
  const showAssignee = GetMultiRole(["admin", "super admin", "management", "manager", "coordinator", "sales co-ordinator", "proc co-ordinator"]);

  return (
    <div className="w-full h-full px-2 sm:px-4 py-2">
      <div className="w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3">
        <div className="w-full md:w-auto flex justify-between items-center gap-2">
          <Breadcrumb items={[{ name: "Procurement" }, { name: "YPR" }]} />
          <div className="flex md:hidden items-center gap-2">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && (
              <FilterButton handleClick={() => clearFilter()} label="Clear" />
            )}
            {GetAccess("purchase_request_create") && (
              <Link to="/procurement/purchase-requests/create">
                <CreateButton label="YPR" />
              </Link>
            )}
          </div>
        </div>

        <div className="w-full md:w-auto flex flex-wrap md:flex-nowrap items-center gap-2">
          <div className="w-full md:w-fit">
            <SearchBar
              handleChange={(e) => {
                setParams({ ...params, search: e.target.value, page: 1 });
                setPage(1);
              }}
              value={params.search}
            />
          </div>
          <div className="hidden md:flex items-center gap-2">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && (
              <FilterButton handleClick={() => clearFilter()} label="Clear" />
            )}
          </div>

          {/* Table / Card View Toggle */}
          <ViewToggle
            viewMode={effectiveViewMode}
            onViewChange={(mode) => setViewMode(mode)}
            storageKey="prViewMode"
          />

          <div className="hidden md:flex items-center gap-2">
            {GetAccess("purchase_request_create") && (
              <Link to="/procurement/purchase-requests/create">
                <CreateButton label="YPR" />
              </Link>
            )}
          </div>
        </div>
      </div>

      <PremiumTable
        data={processedData}
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        viewMode={effectiveViewMode}
        headers={[
          { title: "YPR", width: (!showCustomer && !showAssignee) ? "auto" : "180px" },
          ...(showCustomer ? [{ title: "Customer", width: "auto" }] : []),
          ...(showAssignee ? [{ title: "RFQ Assignee", width: showCustomer ? "180px" : "auto" }] : []),
          { title: "Assign. Date", width: "130px" },
          { title: "DeadLine", width: "130px" },
          { title: "Days Elapsed", width: "120px" },
          ...(GetMultiRole(["admin", "super admin", "management", "manager", "coordinator"]) ? [{ title: "Salesman", width: "160px" }] : []),
          { title: "Status", width: "120px" },
          { title: "Action", align: "center", width: "140px" }
        ]}
        renderRow={(row, idx) => (
          <PRTableRow
            row={row}
            isSelected={listofNumbers.includes(row.prId)}
            onSelect={() => selectOneFunction(row.prId)}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
            onToggleRead={handleToggleReadStatus}
            loadingPrId={loadingPrId}
          />
        )}
        renderCard={(row, idx) => (
          <PRCard
            row={row}
            isSelected={listofNumbers.includes(row.prId)}
            onSelect={() => selectOneFunction(row.prId)}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
            onToggleRead={handleToggleReadStatus}
            loadingPrId={loadingPrId}
          />
        )}
        dataLoading={dataLoading}
        listofNumbers={listofNumbers}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        showEdit={showEdit}
        setShowEdit={setShowEdit}
        multiEditLabel="Multi Edit"
      />

      {showFilterDialog && (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-xs z-[9999] flex justify-center items-center p-3 sm:p-4">
          <div className="animate-scale-in w-[92vw] sm:w-[520px] md:w-[620px] max-w-full max-h-[85vh] bg-white p-5 sm:p-6 rounded-2xl shadow-2xl overflow-y-auto flex flex-col">
            <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-4">
              <h2 className="text-lg font-bold text-gray-800">Filter YPR</h2>
              <button
                onClick={closeFilterDialog}
                type="button"
                className="text-gray-400 hover:text-gray-600 p-1 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <form onSubmit={formik.handleSubmit} className="flex flex-col gap-3">
              <div className="flex flex-col sm:flex-row flex-wrap -mx-2">
                <div className="w-full px-2 mb-2">
                  <p className="text-xs font-semibold text-gray-700 mb-1">Deadline Range</p>
                  <div className="sm:flex gap-2">
                    <NuDate
                      label="From"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="deadLineFrom"
                      width="sm:w-1/2"
                    />
                    <NuDate
                      label="To"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="deadLineTo"
                      width="sm:w-1/2"
                    />
                  </div>
                </div>

                <FormikSelectTwo
                  label="RFQ Assignee"
                  placeholder="RFQ Assignee"
                  Options={RFQAssignee}
                  formik={formik}
                  name="rfqAssignee"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  type="text"
                  label="Sales Person"
                  placeholder="Choose"
                  Options={Salesman}
                  formik={formik}
                  name="salesPerson"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  type="text"
                  label="YPR Category"
                  placeholder="Choose"
                  Options={Category}
                  formik={formik}
                  name="category"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  type="text"
                  label="Status"
                  placeholder="Status"
                  Options={status}
                  formik={formik}
                  name="status"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  type="text"
                  label="Approval Status"
                  placeholder="Approval Status"
                  Options={[
                    { value: "pending", label: "Pending" },
                    { value: "Verified", label: "Verified" },
                    { value: "declined", label: "Decline" },

                  ]}
                  formik={formik}
                  name="approvalStatus"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  type="text"
                  label="Read Status"
                  placeholder="Choose"
                  Options={[
                    { value: "true", label: "Read" },
                    { value: "false", label: "Unread" },
                  ]}
                  formik={formik}
                  name="isRead"
                  width="w-full sm:w-1/2"
                  px="2"
                />
              </div>

              <div className="flex justify-end gap-2.5 pt-4 mt-2 border-t border-gray-100">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}

      {showImportModal && (
        <Importdoc
          show={showImportModal}
          onClose={closeModal}
          getData={getData}
        />
      )}
      {showEdit && (
        <MultiEditPr
          data={listofNumbers}
          getData={getData}
          onClose={() => setShowEdit(false)}
        />
      )}
      <ModalContainer
        visiable={showDelete}
        title="Warning"
        content={`Are you sure, All selected datas will be removed from YPR List!`}
        handleClick={() => { }}
        closeModal={() => setShowDelete(false)}
      />
    </div>
  );
}

export default PRIndex;
